// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons

import {
  faCode, faHighlighter, faUser, faGraduationCap, faSchool, faUniversity, faClock,
  faHandPointUp, faHome, faEnvelope, faPhoneAlt

} from '@fortawesome/free-solid-svg-icons';
// import your social media icon
import { faFacebookF, faWhatsapp, faTwitter, faInstagram, faPinterestP, faHackerrank, faGithub, faLinkedinIn }
  from '@fortawesome/free-brands-svg-icons'

library.add(
  faHackerrank,
  faGithub,
  faLinkedinIn,
  faFacebookF,
  faWhatsapp,
  faTwitter,
  faInstagram,
  faPinterestP,
  faPhoneAlt,
  faEnvelope,
  faHome,
  faGraduationCap,
  faUser,
  faCode,
  faHighlighter,
  faSchool,
  faUniversity,
  faClock,
  faHandPointUp
  // more icons go here
);